/* Base translations · W10 worksheet — moved unchanged out of lib/i18n.js (STEP 2 · B2).
   Top-level keys owned by this file (no other base file and not i18n.js define them): w10. */
export const I18N_BASE_W10 = {
  en: {
    w10: {
      title: "Audit summary memo",
      subtitle: "Aggregate of the audit conclusions and proposed opinion (W10).",
      refresh: "Refresh",
      refreshing: "Refreshing…",
      refreshed: "Refreshed.",
      pulls: "Pulled from other worksheets",
      pull: {
        materiality: "Materiality (105(a))",
        w9: "Uncorrected misstatements (W9)",
        risks: "Significant risks and responses",
        gc: "Going concern (209(a))",
        w8: "Estimates (W8)",
        w16: "Related parties (W16)",
        cd: "Control deficiency log",
        subs: "Subsequent events",
      },
      om: "Overall materiality", pm: "Performance materiality", ct: "Clearly trivial",
      aggCompared: "Compared aggregate", vsPm: "vs PM", vsOm: "vs OM",
      w9Conclusion: "W9 conclusion",
      w9NotMaterial: "Not material", w9Material: "Material",
      pending: "Pending", none: "None recorded.",
      notBuilt: "Not built yet",
      notStarted: "Not started",
      na: "Not applicable",
      gcOption: "Conclusion",
      gcPending: "Not yet concluded",
      open: "Open",
      cdCount: "deficiencies",
      auditorText: "Auditor's text",
      sigMatters: "Significant matters",
      sigMattersPh: "Describe the significant matters arising during the audit.",
      sigJudgments: "Significant judgments and estimates",
      sigJudgmentsPh: "Describe the significant judgments made.",
      proposedOpinion: "Proposed opinion",
      pickOpinion: "Pick a proposed opinion…",
      opinion: {
        unmodified: "Unmodified",
        qualified: "Qualified",
        adverse: "Adverse",
        disclaimer: "Disclaimer of opinion",
      },
      eom: "Emphasis of matter paragraph included",
      om2: "Other matter paragraph included",
      notePh: "Basis / note",
      signoff: "Sign-off",
      preparer: "Preparer", reviewer: "Reviewer", partner: "Partner",
      signOff: "Sign off",
      signedOffBy: "Signed off by {name} · {date}",
      signedOk: "Sign-off recorded.",
      changeDate: "Change date",
      reviewTitle: "Review conclusion",
      reviewSubtitle: "Read-only summary of the practitioner's review conclusion (from W17.8) — audit-opinion selection is not applicable on a Review engagement.",
      reviewConclusion: "Review conclusion",
      reviewConclusionOpen: "Open W17.8",
      reviewConclusionUnset: "Not yet picked on W17.8.",
    },
  },
  ar: {
    w10: {
      title: "مذكرة ملخص المراجعة",
      subtitle: "تجميع لاستنتاجات المراجعة والرأي المقترح (W10).",
      refresh: "تحديث",
      refreshing: "جاري التحديث…",
      refreshed: "تم التحديث.",
      pulls: "بيانات مستقاة من أوراق العمل الأخرى",
      pull: {
        materiality: "الأهمية النسبية (\u2066105(a)\u2069)",
        w9: "التحريفات غير المصحّحة (\u2066W9\u2069)",
        risks: "المخاطر الجوهرية والاستجابات",
        gc: "الاستمرارية (\u2066209(a)\u2069)",
        w8: "التقديرات (\u2066W8\u2069)",
        w16: "الأطراف ذات العلاقة (\u2066W16\u2069)",
        cd: "سجل نواقص الرقابة",
        subs: "الأحداث اللاحقة",
      },
      om: "الأهمية النسبية الإجمالية", pm: "الأهمية النسبية للأداء", ct: "الأهمية الضئيلة",
      aggCompared: "رقم المقارنة الإجمالي",
      vsPm: "مقارنة بالأهمية النسبية للأداء",
      vsOm: "مقارنة بالأهمية النسبية الإجمالية",
      w9Conclusion: "استنتاج W9",
      w9NotMaterial: "غير جوهرية", w9Material: "جوهرية",
      pending: "قيد الانتظار", none: "لا يوجد.",
      notBuilt: "لم يُبنَ بعد",
      notStarted: "لم يبدأ",
      na: "غير منطبق",
      gcOption: "الاستنتاج",
      gcPending: "لم يُختَم بعد",
      open: "فتح",
      cdCount: "نقص",
      auditorText: "نص المدقّق",
      sigMatters: "المسائل الجوهرية",
      sigMattersPh: "صِف المسائل الجوهرية التي ظهرت خلال المراجعة.",
      sigJudgments: "الأحكام والتقديرات الجوهرية",
      sigJudgmentsPh: "صِف الأحكام الجوهرية.",
      proposedOpinion: "الرأي المقترح",
      pickOpinion: "اختَر الرأي المقترح…",
      opinion: {
        unmodified: "غير معدَّل",
        qualified: "متحفظ",
        adverse: "معاكس",
        disclaimer: "امتناع عن الرأي",
      },
      eom: "تضمين فقرة \"لفت انتباه\"",
      om2: "تضمين فقرة \"مسائل أخرى\"",
      notePh: "الأساس / ملاحظة",
      signoff: "التوقيع",
      preparer: "المُعِدّ", reviewer: "المراجع", partner: "الشريك",
      signOff: "التوقيع",
      signedOffBy: "وقّع {name} · {date}",
      signedOk: "تم التوقيع.",
      changeDate: "تغيير التاريخ",
      reviewTitle: "خلاصة الفحص",
      reviewSubtitle: "ملخّص للقراءة فقط لخلاصة الممارس للفحص (من \u2066W17.8\u2069) — لا ينطبق اختيار رأي المدقّق على ارتباط الفحص.",
      reviewConclusion: "خلاصة الفحص",
      reviewConclusionOpen: "فتح \u2066W17.8\u2069",
      reviewConclusionUnset: "لم تُختَر بعد في \u2066W17.8\u2069.",
    },
  },
};

export default I18N_BASE_W10;
